<template>
  <!-- Grid Single  -->
  <section class="grid_single big_container">
    <div class="grid_item">
      <a :href="shopifyData.link" class="grid_img-wrap single line-h-0 d-block">
        <picture>
          <source
            media="(max-width:767px)"
            :srcset="shopifyData.responsiveimgUrl.src"
            :src-placeholder="shopifyData.responsiveimgUrl.placeholder"
            :alt="shopifyData.responsiveimgUrl.alt || 'Mobile Grid Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Mobile Grid Image"
            width=""
            height=""
          />
          <img
            v-lazy="shopifyData.imgUrl.src"
            class="grid_img single"
            :src-placeholder="shopifyData.imgUrl.placeholder"
            :alt="shopifyData.imgUrl.alt || 'Grid Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Desktop Grid Image"
            width=""
            height=""
            :style="{ height: imageHeight + 'px' }"
          />
        </picture>
      </a>
      <div class="grid_info">
        <h3 class="card_heading grid_heading" v-html="shopifyData.title" />
        <a :href="shopifyData.link" class="link body_text" v-html="shopifyData.linktext" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    window.addEventListener('resize', this.setImageHeight);
    return {
      imageHeight: 'auto',
    };
  },
  mounted() {
    this.setImageHeight();
  },
  methods: {
    setImageHeight() {
      if (window.innerWidth >= 768) {
        this.imageHeight = this.shopifyData.imageHeight;
      } else {
        this.imageHeight = this.shopifyData.MobileimageHeight;
      }
    },
  },
};
</script>

<style scoped>
.grid_single {
  padding: 40px 15px 20px;
}

@media only screen and (max-width: 991px) {
  .grid_single {
    padding: 0px 0px 35px;
  }
}
</style>
